import React from "react";

import '../styles/hero-styles.css'

function LoadHero() {
    return (
        <div className="container" id="hero-container">
            <h1>Transforming business and Research with <span className="custom-gradient-text">Bespoke AI</span></h1>
            <p>We build custom, high-impact Al solutions that solve complex challenges, optimize operations, and unlock new opportunities. From advanced computer vision to autonomous agentic workflows, we are your strategic Al partner.</p>
        </div>
    )
}

export default LoadHero;